var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.421,
    height: 21.745,
    viewBox: "0 0 25.421 21.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(-1080.218 -101.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M1101.749,113.348v5.767h-17.64v-5.767h-3.391v7.462a1.7,1.7,0,0,0,1.7,1.694h21.025a1.7,1.7,0,0,0,1.7-1.694v-7.462Z",
    fill: "#6c5b7b",
    stroke: "#dee2e6",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M1092.618,117.276l-4.854-5.865s-.738-.7.063-.7h2.735v-8.538s-.109-.416.518-.416h3.85c.451,0,.441.35.441.35v8.428h2.525c.972,0,.24.73.24.73s-4.13,5.483-4.706,6.058A.539.539,0,0,1,1092.618,117.276Z",
    fill: "#6c5b7b",
    stroke: "#dee2e6",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.90646aea5390800bc3392bc09e25a437.svg";
export { ForwardRef as ReactComponent };